export default __webpack_public_path__ + "static/media/Page14.bce992eb.txt";